import { render, staticRenderFns } from "./Blank_add_page.vue?vue&type=template&id=ed969360&scoped=true"
import script from "./Blank_add_page.vue?vue&type=script&lang=js"
export * from "./Blank_add_page.vue?vue&type=script&lang=js"
import style0 from "./Blank_add_page.vue?vue&type=style&index=0&id=ed969360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed969360",
  null
  
)

export default component.exports